import React from 'react';
import s from './Loading.module.scss';

import Logo from 'assets/images/dogmented/logo.svg'

export default function Loading(props) {
  
  return (
    <div className={s.loading}>
      {/* <div className={s.overlay}></div> */}
      <div className={s.content}>
        <img src={Logo} alt="" />
        <p className={s.inspire}>Movement that inspires</p>
        <p>Loading...</p>
      </div>
    </div>
  );
}